<template>
  <AdminMachineList :lockedFilters="{ MachineTypeIdList: [$route.params.typeId] }" hideMachineTypeFilter />
</template>


<script>
import AdminMachineList from "@/views/admin/machines/AdminMachineList.vue";


export default {
  name: "ViewMachineTypeMachineList",
  props: {},
  components: {
    AdminMachineList,
  },

  data() {
    return {};
  },

  mounted() { },

  methods: {},

  computed: {},

  watch: {},
};
</script>


<style lang='scss'></style>